import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import { JoinFaculty } from "../components/community-faculty/JoinFaculty";
import { useLoader } from "../context/LoaderContext";
import { fetchJoinAsFacultyDetails } from "../api/JoinAsFacultyApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import { IBannerData, IJoinAsFacultyDetailsData } from "../exports/interfaces";
import { fetchJoinasFacultyBanner } from "../api/BannerApi";
 
const CommunityFacultyPage = () => {
  const { setLoading } = useLoader();
  const [joinAsFacultyDetails, setJoinAsFacultyDetails] = useState<
    IJoinAsFacultyDetailsData[]
  >([]);
    const [joinasFacultyBanner, setJoinasFacultyBanner] = useState<IBannerData[]>([]);
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchJoinAsFacultyDetails(),fetchJoinasFacultyBanner()])
      .then(([joinAsFacultyDetailsData, joinasFacultyBannerData]) => {
        setJoinAsFacultyDetails(joinAsFacultyDetailsData);
        setJoinasFacultyBanner(joinasFacultyBannerData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <Banner title="Community" bannerImage={joinasFacultyBanner?.[0]?.image?.[0]}/>
      <JoinFaculty joinAsFacultyDetails={joinAsFacultyDetails} />
    </>
  );
};

export default CommunityFacultyPage;
